export function formatNumber(value) {
    if (!value) return '0';

    // Versuche, den Wert in eine Zahl umzuwandeln
    const number = Number(value);

    // Prüfe, ob der konvertierte Wert tatsächlich eine gültige Zahl ist
    if (isNaN(number)) return '0'; // Falls nicht, gib den ursprünglichen Wert zurück

    // Gib die Zahl mit Tausendertrennzeichen zurück
    return number.toLocaleString();
}